import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _typeof from "@babel/runtime/helpers/typeof";
import { HIGHLIGHT_PATTERN } from '../../constants';
export function prepareHighlightParts(text) {
  if (!text || !['string', 'number'].includes(_typeof(text))) {
    return [];
  }
  var content = [];
  var cursorPos = 0;
  var textToMatch = typeof text === 'number' ? text.toString() : text;
  var _iterator = _createForOfIteratorHelper(textToMatch.matchAll(HIGHLIGHT_PATTERN)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var match = _step.value;
      var _match = _slicedToArray(match, 2),
        fullMatch = _match[0],
        substr = _match[1];
      var _match$index = match.index,
        index = _match$index === void 0 ? -1 : _match$index,
        _match$input = match.input,
        input = _match$input === void 0 ? '' : _match$input;
      // если позиция матча больше позиции курсора,
      // это значит что между курсором и матчем есть текст, который не нужно хайлайтить.
      if (index > cursorPos) {
        content.push({
          substr: input.slice(cursorPos, index)
        });
      }
      content.push({
        substr: substr,
        highlighted: true
      });
      // переводим курсор на [позицию последней буквы "подсвеченной" подстроки] + 1
      cursorPos = index + fullMatch.length;
    }
    // если прошлись по всем подсвеченным подстрокам, а строка еще не кончилась, то
    // запихиваем оставшуюся подстроку
    // или если строка не матчится, то возьмется весь контент
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (cursorPos < textToMatch.length) {
    content.push({
      substr: textToMatch.slice(cursorPos, textToMatch.length)
    });
  }
  return content;
}
// #sourceMappingURL=utils.js.map